import api from './api';

const businessInfoService = {
  /**
   * Obtener información del negocio
   */
  async get() {
    try {
      const response = await api.get('/business-info');
      return {
        success: true,
        data: response.data.data
      };
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || 'Error al obtener información del negocio'
      };
    }
  },

  /**
   * Actualizar información del negocio
   */
  async update(businessData) {
    try {
      const response = await api.put('/business-info', businessData);
      return {
        success: true,
        data: response.data.data,
        message: response.data.message
      };
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || 'Error al actualizar información del negocio'
      };
    }
  }
};

export default businessInfoService;


